<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "patroltemplate",
      key: "id",
      url: {
        get: "/admin/system/template",
        add: "/admin/system/template",
        edit: "/admin/system/template",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "巡检名称",
          name: "patrolName",
          value: "",
          type: "input",
          width: "200px",
          rules: [{ required: true, trigger: 'blur'}],
        },
        {
          label: "巡检维度类别",
          name: "patrolDimension",
          value: 1,
          type: "select",
          width: "240px",
          dropList: [
            { value: 1, name: "资产" },
            { value: 2, name: "巡检场景" },
          ],
          onChange: this.onChangeType,
          rules: [{ required: true, trigger: 'blur', type: 'number'}],
        },
        {
          label: "",
          name: "facilityList",
          value: "",
          type: "multiple",
          dropList: [],
          onChange: this.onCouponAlisdata,
        },
        {
          label: "",
          name: "facilityList1",
          value: "",
          type: "multiple",
          dropList: [],
          onChange: this.onCouponAlis,
        },
        {
          label: "巡检周期",
          name: "patrolInterval",
          value: "",
          type: "number",
          width: "200px",
          rules: [{ required: true, trigger: 'blur', type: 'number'}],
        },
        {
          label: "周期单位",
          name: "timeUnit",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            // {
            //   value: 1,
            //   name: "分钟",
            // },
            {
              value: 2,
              name: "小时",
            },
            {
              value: 3,
              name: "天",
            },
            // {
            //   value: 4,
            //   name: "周",
            // },
            {
              value: 5,
              name: "月",
            },
            // {
            //   value: 6,
            //   name: "季度",
            // },
            // {
            //   value: 7,
            //   name: "年",
            // },
          ],
          rules: [{ required: true, trigger: 'blur', type: 'number'}],
        },
        // {
        //   label: "巡检开始时间",
        //   name: "patrolBeginTime",
        //   value: "",
        //   type: "date",
        // },
        // { label: "巡检内容", name: "patrolContent", value: "", type: "textarea" },
        // { label: "备注", name: "remark", value: "", type: "textarea" ,width:"400px"},

        // {
        //   label: "负责人",
        //   name: "maintainerId",
        //   value: "",
        //   type: "select",
        // width: "240px",
        //   dropList: [],
        // },
      ],
      forms: {},
    };
  },
  created() {
    this.loaduserData();
    this.loadfacilityNoData();
    this.loadfacilityNoData1();
  },
  mounted() {
    if(this.forms.patrolDimension = 2){
    this.items[this.getItemIndex("facilityList1")].type = "multiple";
        this.items[this.getItemIndex("facilityList")].type = "kong";
    }
    if(this.forms.patrolDimension = 1){
      this.items[this.getItemIndex("facilityList1")].type = "kong";
        this.items[this.getItemIndex("facilityList")].type = "multiple";
    }
  },
  methods: {
      onChangeType(val) {
      if (val == 1) {
        this.items[this.getItemIndex("facilityList1")].type = "kong";
        this.items[this.getItemIndex("facilityList")].type = "multiple";
        this.forms.facilityList1 = ''
      }
      if (val == 2) {
        this.items[this.getItemIndex("facilityList1")].type = "multiple";
        this.items[this.getItemIndex("facilityList")].type = "kong";
        this.forms.facilityList = ''
      }
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/template/${id}`, {}).then((res) => {
        if (res && res.data && res.data.patrolDimension == 1) {
          this.forms = res.data;
          let labelid = res.data.facilityList.split(",");
          this.forms.facilityList = labelid.map(Number);
          this.items[this.getItemIndex("patrolDimension")].value = 1;
          this.items[this.getItemIndex("facilityList1")].type = "kong";
        this.items[this.getItemIndex("facilityList")].type = "multiple";
        }
        if (res && res.data && res.data.patrolDimension == 2) {
          this.forms = res.data;
          let labelid = res.data.facilityList.split(",");
          this.forms.facilityList1 = labelid.map(Number);
          this.items[this.getItemIndex("patrolDimension")].value = 2;
        this.items[this.getItemIndex("facilityList1")].type = "multiple";
          this.items[this.getItemIndex("facilityList")].type = "kong";
        }
      });
    },
    onCouponAlis(val) {
      let ass = val.join(",");
      this.labelid = ass;
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.forms.facilityList = this.Listid;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/template`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onCouponAlisdata(val) {
      let ass = val.join(",");
      this.Listid = ass;
    },
  
    loadfacilityNoData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityList") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadfacilityNoData1() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/scene/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.sceneName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityList1") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.userName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
  },
};
</script>
